import moment from 'moment';
import { getFullName } from '../../../utils';
import React from 'react';
import { styledDefaultColDef, createAvatarNameRenderer, createStatusPillRenderer } from '../../../extras/cellRenderers';

const CoachAvatarRenderer = createAvatarNameRenderer(
  (p) => p.data?.User?.firstName,
  (p) => p.data?.User?.lastName
);

function RegDateGetter(params) {
  const date = params.data?.createdAt;
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 6, height: '100%' }}>
      <span style={{ fontSize: 13, color: '#374151' }}>
        {moment(date).utc().format('DD MMM YYYY')}
      </span>
      <span style={{ fontSize: 11.5, color: '#9CA3AF' }}>
        ({moment(date).utc().fromNow()})
      </span>
    </div>
  );
}

const statusMap = {
  ON_HOLD:  { bg: '#FEF2F2', color: '#DC2626', border: '#FECACA', label: 'On Hold' },
  NEW:      { bg: '#FEF3C7', color: '#B45309', border: '#FDE68A', label: 'New' },
  UPDATED:  { bg: '#EEF2FF', color: '#4F46E5', border: '#C7D2FE', label: 'Updated' },
  APPROVED: { bg: '#ECFDF5', color: '#059669', border: '#A7F3D0', label: 'Approved' },
  REJECTED: { bg: '#FEF2F2', color: '#DC2626', border: '#FECACA', label: 'Rejected' },
};

const StatusPill = createStatusPillRenderer(statusMap);

export const columnDefs = [
  { field: 'userId', hide: true },
  {
    headerName: 'Name',
    field: 'name',
    filter: 'agTextColumnFilter',
    pinned: 'left',
    filterParams: {
      filterOptions: ['contains'],
      valueGetter: (props) => getFullName(props.data?.User),
      debounceMs: 200,
    },
    comparator: (valueA, valueB, nodeA, nodeB, isDescending) => {
      const nameA = getFullName(nodeA.data?.User);
      const nameB = getFullName(nodeB.data?.User);
      const comparison = nameA.localeCompare(nameB);
      return comparison;
    },
    cellRenderer: CoachAvatarRenderer,
  },
  {
    headerName: 'Reg Date',
    field: 'regDate',
    filter: 'agDateColumnFilter',
    filterParams: {
      valueGetter: (props) => moment(props.data?.createdAt),
      debounceMs: 200,
      comparator: (filterLocalDateAtMidnight, cellValue) => {
        const dateAsString = moment(cellValue).format('DD/MM/YYYY');
        if (dateAsString == null) {
          return 0;
        }
        const dateParts = dateAsString.split('/');
        const year = Number(dateParts[2]);
        const month = Number(dateParts[1]) - 1;
        const day = Number(dateParts[0]);
        const cellDate = new Date(year, month, day);

        if (cellDate < filterLocalDateAtMidnight) {
          return -1;
        } else if (cellDate > filterLocalDateAtMidnight) {
          return 1;
        }
        return 0;
      },
    },
    comparator: (valueA, valueB, nodeA, nodeB, isDescending) => {
      const dateA = moment(nodeA.data?.createdAt);
      const dateB = moment(nodeB.data?.createdAt);
      const comparison = dateA.diff(dateB);
      return comparison;
    },
    cellRenderer: RegDateGetter,
  },
  {
    headerName: 'Status',
    field: 'status',
    cellRenderer: StatusPill,
  },
  {
    headerName: 'Take Actions',
    field: 'actions',
    cellRenderer: 'btnCellRenderer',
    pinned: 'right',
    sortable: false,
    suppressMenu: true,
    // comparator: (valueA, valueB, nodeA, nodeB, isDescending) => {
    //   const nameA = getFullName(nodeA.data?.User);
    //   const nameB = getFullName(nodeB.data?.User);
    //   const comparison = nameA.localeCompare(nameB);
    //   return comparison;
    // },
  },
];

export const defaultColDef = {
  ...styledDefaultColDef,
  filter: true,
};
